import React from 'react'
import AppCard from 'components/app-card'
import FGlogo from 'images/family-golf-logo.svg'
import FClogo from 'images/family-cup-logo.svg'
import { useFeatureFlags, flags } from 'lib/feature-flags'

export default function FamilyCup() {
  const [FGRActive] = useFeatureFlags([flags.FLAG_FAMILY_GOLF_REBRAND])
  const rebrand = FGRActive ? 'Golf' : 'Cup'
  const logo = FGRActive ? FGlogo : FClogo
  const signup = FGRActive ? '/family-golf-signup' : '/fc-signup'
  return (
    <AppCard
      title="Create a community at your facility by turning golf into a multi-generational team sport"
      to={signup}
      buttonText="launch"
      testid="family-cup-tile"
      logoStyle={{ height: '70px' }}
      logo={{
        src: logo,
        alt: `PGA Family ${rebrand} logo`,
      }}
    />
  )
}
